export function formatNativeTeamsFeUserAgent(appShortName: string): string {
  return `NativeTeams-FE/${appShortName}`;
}

/** Value for `User-Agent` segment; set `APP_NAME` per app deployment (e.g. auth-app). */
export function resolveOutgoingHttpAppName(): string {
  return process.env.APP_NAME?.trim() || 'unknown';
}

function headersInitToRecord(init?: HeadersInit): Record<string, string> {
  if (!init) return {};
  if (init instanceof Headers) {
    const out: Record<string, string> = {};
    init.forEach((value, key) => {
      out[key] = value;
    });
    return out;
  }
  if (Array.isArray(init)) {
    return Object.fromEntries(init);
  }
  return { ...init };
}

async function resolveOutgoingTraceId(): Promise<string> {
  try {
    const { headers: getHeaders } = await import('next/headers');
    const headersList = await getHeaders();
    const existing = headersList.get('x-trace-id')?.trim();
    if (existing) return existing;
  } catch {
    // Outside a request context (e.g. build) — generate a fresh id.
  }
  return crypto.randomUUID();
}

export async function getOutgoingXTraceIdHeader(): Promise<
  { 'X-Trace-Id': string } | Record<string, never>
> {
  if (typeof window !== 'undefined') return {};
  return { 'X-Trace-Id': await resolveOutgoingTraceId() };
}

export async function mergeServerOutgoingFetchHeaders(
  base?: HeadersInit
): Promise<Record<string, string>> {
  if (typeof window !== 'undefined') {
    return headersInitToRecord(base);
  }

  const traceId = await resolveOutgoingTraceId();
  const outgoing: Record<string, string> = {
    'User-Agent': formatNativeTeamsFeUserAgent(resolveOutgoingHttpAppName()),
    'X-Trace-Id': traceId,
  };

  return { ...headersInitToRecord(base), ...outgoing };
}
